import React, { useState } from "react";
import { fetchExhibitionArtists, fetchExhibitionCurator, fetchOrganisationsCurators } from "../../services/api";
import { constructImageUrl } from "../../utils";
import Card from "../Card";
import FeatureCardList from "../FeatureCardList";

export default function useReadMoreData(uuid, isPreview = false) {
    const [artists, setArtists] = useState([]);
    const [exhibitionCurators, setExhibitionCurators] = useState(null);
    const [organisationCurator, setOrganisationCurators] = useState(null);

    const handleGalleryClick = (galleryId, isOrganisation = false) => {
        const link = `/${isOrganisation ? 'organisations' : 'galleries'}/${galleryId}`
        window.open(link, "_blank").focus();
    };

    const handleArtistClick = (artistId) => {
        window.open(`/artists/${artistId}`, "_blank").focus();
    };

    const handleCuratorClick = (curatorId) => {
        window.open(`/curators/${curatorId}`, "_blank").focus();
    };

    const getGallery = (organisation, isOrganisation = false, isListview = false) => {
        const Img = constructImageUrl(organisation?.data?.image, '720');
        return (
            <>
                <Card
                    imgSrc={organisation?.data?.image && Img}
                    title={organisation?.data?.name}
                    description={organisation?.data?.overview}
                    location={organisation?.data?.locations}
                    onClick={() => handleGalleryClick(organisation?.data?.slug || organisation?.data?.id, isOrganisation)}
                    curator={isOrganisation}
                    listviewGallery={isListview}
                />
            </>
        );
    }

    const getOrganisationCurators = () => {
        return (
            <div className="curators-wrapper">
                {
                    organisationCurator?.length > 0 && organisationCurator.map((item, index) => {
                        const { data } = item;
                        if (data?.title || data?.description || data.image) {
                            return (
                                <Card
                                    key={index}
                                    imgSrc={constructImageUrl(data.image, '720')}
                                    title={data.title}
                                    description={data.description}
                                    onClick={() => handleCuratorClick(data.uuid || data.slug || data.id)}
                                    curator
                                />
                            )
                        }
                    })
                }
            </div>
        );
    }

    const getExhibitionCurator = (isReadMore = false) => {
        return (
            <div className="curators-wrapper">
                {
                    exhibitionCurators?.length > 0 &&
                    exhibitionCurators.map((exhibitionCurator, index) => {
                        return (
                                <Card
                                    imgSrc={constructImageUrl(exhibitionCurator?.data?.curator?.data?.image, '720')}
                                    title={exhibitionCurator?.data?.curator?.data?.title}
                                    description={exhibitionCurator?.data?.curator?.data?.description}
                                    onClick={() => handleCuratorClick(exhibitionCurator?.data?.curator?.data?.uuid || exhibitionCurator?.data?.curator?.data?.slug || exhibitionCurator?.data?.curator?.data?.slug)}
                                    curator={true}
                                    curatorReadMore={isReadMore}
                                    key={index}
                                />
                        )
                    })
                }
            </div>
        );
    }

    const getArtists = () => {
        return <>
            {artists.length > 0 && artists.map((artist, index) => {
                const Img = constructImageUrl(artist?.data?.image, '720');
                return (
                    <Card
                        key={index}
                        imgSrc={artist.data.image && Img}
                        title={artist.data.name}
                        description={artist.data.description}
                        onClick={() => handleArtistClick(artist.data.slug || artist.data.id)}
                    />
                )
            })} </>
    }

    const getCuratorsFeature = () => {
        return (
            exhibitionCurators?.length > 0 &&
            <FeatureCardList 
                title={exhibitionCurators.length > 1 ? "Curators" : "Curator"}
                cards={exhibitionCurators}
                type="curators"
            />
        )
    }

    const getArtistsFeature = () => {
        return (
            artists.length > 0 &&
            <FeatureCardList 
                title={artists.length > 1 ? "Artists" : "Artist"}
                cards={artists}
                type="artists"
            />
        )
    }
    
    const getGalleryFeature = (organisation, isOrganisation) => {
        return (
            <FeatureCardList 
                title="Presented by..."
                type={isOrganisation ? 'organisations' : 'galleries'}
                variant="secondary"
                card={{
                    image: organisation?.data?.image,
                    name: organisation?.data?.name,
                    description: organisation?.data?.overview,
                    location: organisation?.data?.locations,
                    slug: organisation?.data?.slug,
                    id: organisation?.data?.id
                }}
            />
        )
    }

    const loadOrganizationCurators = async (id) => {
        if (id) {
            return new Promise(async (resolve, reject) => {
                const curatorResp = await fetchOrganisationsCurators(id);
                if (curatorResp) {
                    setOrganisationCurators(curatorResp);
                    resolve(true)
                } else {
                    resolve(true)
                }
            })
        }
    }

    const loadCurator = async () => {
        if (uuid) {
            return new Promise(async (resolve, reject) => {
                const curatorResp = await fetchExhibitionCurator(uuid, isPreview);
                if (curatorResp?.length > 0) {
                    setExhibitionCurators(curatorResp);
                    resolve(true)
                } else {
                    resolve(true)
                }
            })
        }
    }

    const loadExhibitionArtists = async () => {
        if (uuid) {
            const artistsResp = await fetchExhibitionArtists(uuid, isPreview);

            if (artistsResp.data) {
                setArtists(artistsResp.data);
            }
        }
    };
    return {
        loadExhibitionArtists,
        handleGalleryClick,
        getArtists,
        getGallery,
        getOrganisationCurators,
        loadOrganizationCurators,
        getExhibitionCurator,
        loadCurator,
        artists,
        exhibitionCurators,
        organisationCurator,
        getArtistsFeature,
        getGalleryFeature,
        getCuratorsFeature
    }
}